import { LIST_FEED, LAST_POST, LIKE_FEED, LIKE_FEED_LIST, POST_DETAIL, COMMENT_FEED_LIST, COMMENT_FEED, LIKE_COMMENT, LIKE_COMMENT_LIST, IMAGE_CAROUSAL,IMAGE_LIST ,POST_FRIEND, DELETE_POST , EDIT_POST} from './constants';
import { getPublicIP, getAuthHeader } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse, loader, pageloader} from './utils';

export const createPost = (newpost) => {
 
  return {
    type: LAST_POST,
    newpost,
  }; 
};

export const editPost = (editPost) => {
  return {
    type: EDIT_POST,
    editPost,
  }; 
};
export const listFeed = (listfeed,pagination) => {
  return {
    type: LIST_FEED,
    listfeed,
    pagination
  }; 
};
export const likeFeedList = (likeFeedList) => {
  return {
    type: LIKE_FEED_LIST,
    likeFeedList
  }; 
};
export const commentFeedList = (commentFeedList) => {
  return {
    type: COMMENT_FEED_LIST,
    commentFeedList
  }; 
};
export const likeFeedResponse = (likeFeedResponse) => {
  return {
    type: LIKE_FEED,
    likeFeedResponse
  }; 
};
export const postDetail = (postDetail) => {
  return {
    type: POST_DETAIL,
    postDetail
  }; 
};
export const commentFeedResponse = (commentFeedResponse) => {
  return {
    type: COMMENT_FEED,
    commentFeedResponse
  }; 
};
export const likeCommentResponse = (likeCommentResponse) => {
  return {
    type: LIKE_COMMENT,
    likeCommentResponse
  }; 
};
export const likeCommentList = (likeCommentList) => {
  return {
    type: LIKE_COMMENT_LIST,
    likeCommentList
  }; 
};
export const openCarousal = (imageCarousal) => {
  return {
    type: IMAGE_CAROUSAL,
    imageCarousal
  }; 
};
export const imageList = (imageList) => {
  return {
    type: IMAGE_LIST,
    imageList
  };  
};


export const createPostRequest = (params) => {
   
   return (dispatch, getState) => {
    const bodyFormData = new FormData();
    let contents = params.post_content.replace(/(?:\r\n|\r|\n)/g, '\n');
    contents = params.post_content.replace(/<a/g,'<b><a');
    contents = contents.replace(/<\/a>/g,'</a></b>');
        
    const {login} = getState();
    bodyFormData.set('user_id', login.user.id);
    bodyFormData.set('content', `<font face='Open Sans' color=#616161 font size = 4px>${contents}</font>`);
    bodyFormData.set('media_files', JSON.stringify(params.media_files));
    bodyFormData.set('access_type', 'FRIENDS');
    bodyFormData.set('tagged_user', JSON.stringify(params.tagged_user));
    bodyFormData.set('dedicate_user', JSON.stringify(params.dedicated_user));
    bodyFormData.set('is_web', 1);
    const headers = getAuthHeader('en');
    loader(true);
    postReq(`${apiURLPrefix}/userfeed/createpost`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(createPost(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }  
};
export const fetchFeedRequest = (params = null) => {
   
  return (dispatch, getState) => {
    const pagination = (params != null) ? params.pagination : 0;
    const bodyFormData = new FormData();
    const {login} = getState();
    if(params.pagination == 0){
      loader(true);
    }else{
      pageloader(true);
    }
    //bodyFormData.set('user_id', login.user.id);
    bodyFormData.set('pagination', pagination);
    const headers = getAuthHeader('en');
    postReq(`${apiURLPrefix}/userfeed/fetch_userfeed`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      pageloader(false);
      dispatch(listFeed(res,pagination));
    }).catch((err)=>{
      pageloader(false);
      console.log(err)
    }) 
  }  
};
export const updateLikeFeed = (params = null) => {
   //console.log(params);
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('comment_type', params.comment_type);
    bodyFormData.set('content_id', params.content_id);
    bodyFormData.set('reaction', params.reaction);
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/userfeed/user_like`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(likeFeedResponse(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};
export const fetchLikeFeed = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('feed_id', params.feed_id);
    bodyFormData.set('return_type', params.return_type);
    bodyFormData.set('flag', params.flag);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/userprofile/feed_reaction`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(likeFeedList(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};
export const fetchPostDetails = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('feed_id', params);
    
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/userfeed/post_details`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(postDetail(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};
export const fetchCommentFeed = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('feed_id', params.feed_id);
    bodyFormData.set('return_type', params.return_type);
    bodyFormData.set('flag', params.flag);
    const headers = getAuthHeader();
    loader(true);
    postReq(`${apiURLPrefix}/userprofile/feed_reaction`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(commentFeedList(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};
export const updateCommentFeed = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('comment_type', params.comment_type);
    bodyFormData.set('content_id', params.content_id);
    if(params.parent_comment_id != null){
      bodyFormData.set('parent_comment_id', params.parent_comment_id);
    }
    if(params.image != null){
      bodyFormData.set('image', params.image);
      bodyFormData.set('image_type', params.image_type);
    }
    bodyFormData.set('comment', params.comment);
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/userfeed/user_comment`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      dispatch(commentFeedResponse(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};
export const updateLikeComment = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    if (params.data_type == 'Promotion'){
      bodyFormData.set('promotion_id', params.promotion_id);
    }else{
      bodyFormData.set('feed_id', params.feed_id);
    }
    bodyFormData.set('comment_id', params.comment_id);
    bodyFormData.set('reaction', params.reaction);
   
    loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/userfeed/user_commentlike`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      res.comment_id = params.comment_id;
      res.section    = params.section;
      dispatch(likeCommentResponse(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};
export const fetchLikeComment = (params = null) => {
   
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('comment_id', params.comment_id);
    bodyFormData.set('flag', params.flag);
   // loader(true);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/userprofile/feed_commentreaction`, bodyFormData , headers)
    .then(handleResponse)
    .then((res) => {
      res.comment_id = params.comment_id;
      res.section    = params.section;
      dispatch(likeCommentList(res));
    }).catch((err)=>{
      console.log(err)
    }) 
  }  
};
export const showCarousal = (params) => {
  return (dispatch,getState) => {
     dispatch(openCarousal(params));
  }
};

export const multipleImageList = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    bodyFormData.set('feed_id', params.feedId);
    bodyFormData.set('flag', params.flag);
    const headers = getAuthHeader();
    loader(true);
    postReq(`${apiURLPrefix}/usergallery/multipleimage_details`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(imageList(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }
} 

export const userFriendlist = (postFriend) => {
  return {
    type: POST_FRIEND,
    postFriend
  }; 
};
export const getUserFriendlist = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('user_id', login.user.id);
    if(params.friend_search == ''){
      bodyFormData.set('pagination', params.friend_pagination);
    }

    bodyFormData.set('flag', 'ALL');
    bodyFormData.set('search_text', params.friend_search);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/userprofile/user_friendlist`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
     
      dispatch(userFriendlist(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }
} 

export const deletePost = (deletePost) => {
  return {
    type: DELETE_POST,
    deletePost
  };  
};


export const deletePostRequest = (params) => {
   
   return (dispatch, getState) => {
    const bodyFormData = new FormData();
    const {login} = getState();
    bodyFormData.set('post_id', params.post_id);
    bodyFormData.set('feed_id', params.feed_id);
    bodyFormData.set('feed_type', params.feed_type);

    const headers = getAuthHeader('en');
    loader(true);
    postReq(`${apiURLPrefix}/userfeed/delete_userpost`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(deletePost(params));
    }).catch((err)=>{
      console.log(err);
    }) 
  }  
};


export const editPostRequest = (params) => {
   
  return (dispatch, getState) => {
   const bodyFormData = new FormData();
   let contents = params.post_content.replace(/(?:\r\n|\r|\n)/g, '\n');
   contents = params.post_content.replace(/<a/g,'<b><a');
   contents = contents.replace(/<\/a>/g,'</a></b>');
       
   const {login} = getState();
   bodyFormData.set('user_id', login.user.id);
   bodyFormData.set('content', `<font face='Open Sans' color=#616161 font size = 4px>${contents}</font>`);
   bodyFormData.set('media_files', JSON.stringify(params.media_files));
   bodyFormData.set('access_type', 'FRIENDS');
   bodyFormData.set('tagged_user', JSON.stringify(params.tagged_user));
   bodyFormData.set('dedicate_user', JSON.stringify(params.dedicated_user));
   bodyFormData.set('is_web', 1);
   bodyFormData.set('feed_id', params.feedId);
   bodyFormData.set('post_id', params.postId);
   
   const headers = getAuthHeader('en');
   loader(true);
   postReq(`${apiURLPrefix}/userfeed/editpost`, bodyFormData , headers)
   .then(handleResponse) 
   .then((res) => {
     dispatch(editPost(res));
   }).catch((err)=>{
     console.log(err);
   }) 
 }  
};